import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { AppTokenHandler } from '../common/app-token-handler';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DataService } from '../common/data.service';
import { AppInsightsService } from './app-insights.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService {
    constructor(private appToken: AppTokenHandler, private route: Router, private gservice: DataService
        , private appInsightsService : AppInsightsService
    ) {
        this.route.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                this.LogPageAnalytics();
            }
        });
    }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        sessionStorage.setItem('redirectUrl', state.url);
        if (this.appToken.getSessionToken().length > 0) {
            return true;
        }
        this.route.navigate(['/unauthorize']);
      return false;

    };
    LogPageAnalytics() {
        let IsLogAppInsights = false;
        let UserInfo = this.appToken.getLoginUserInfo();
        if (UserInfo != null && UserInfo.IsAzureInsights != null) {
            IsLogAppInsights = UserInfo.IsAzureInsights;
        }
        if (IsLogAppInsights) {
            const username = UserInfo.EmpGPN; // Replace with actual username retrieval logic
            this.appInsightsService.trackPageView(window.location.href.replace('#/', ''), username);
        }
        // if (environment.logPageAnalytics == 'Y') {
        //     let _url:string = environment.pageAnalyticsUrl + '?PageTitle=' + window.location.href.replace('#/', '') + '&ApplicationCode=' + environment.appcode;
        //     this.gservice
        //         .LogPageAnalytics(_url)
        //         .subscribe(data => {
        //         }, (error) => {
        //         });
        // }
    }
}